import { Route } from '@angular/router';
import {
  BUYER_ROUTES,
  COMMON_ROUTES,
  DEFAULT_AUTHENTICATED_ROUTE_PATH,
  GUEST_ROUTES,
  OPERATOR_ROUTES,
  SUPPLIER_ROUTES,
  SURVEY_ROUTES,
  SURVEY_WORKFLOW_ROUTES,
} from './routes';

import { authGuard, guestGuard } from '@ps/auth-data-access';
import { roleGuard } from '@ps/user-settings-data-access';
import { UserType } from '@ps/core-models';

export const routes: Route[] = [
  {
    path: '',
    redirectTo: DEFAULT_AUTHENTICATED_ROUTE_PATH,
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./layouts/basic-layout/basic-layout.component').then(
        (m) => m.BasicLayoutComponent,
      ),
    children: GUEST_ROUTES,
  },
  {
    path: '',
    canActivate: [authGuard, roleGuard],
    data: { roles: ['buyer'] as UserType[] },
    loadComponent: () =>
      import(
        './layouts/survey-workflow-layout/survey-workflow-layout.component'
      ).then((m) => m.SurveyWorkflowLayoutComponent),
    children: SURVEY_WORKFLOW_ROUTES,
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layouts/app-layout/app-layout.component').then(
        (m) => m.AppLayoutComponent,
      ),
    children: [
      ...COMMON_ROUTES,
      {
        path: '',
        canActivate: [roleGuard],
        data: {
          deniedRoles: ['supplier'] as UserType[],
        },
        children: SURVEY_ROUTES,
      },
      {
        path: '',
        canActivate: [roleGuard],
        data: { roles: ['supplier'] as UserType[] },
        children: SUPPLIER_ROUTES,
      },
      {
        path: '',
        canActivate: [roleGuard],
        data: { roles: ['buyer'] as UserType[] },
        children: BUYER_ROUTES,
      },
      {
        path: '',
        canActivate: [roleGuard],
        data: { roles: ['operator'] as UserType[] },
        children: OPERATOR_ROUTES,
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./layouts/basic-layout/basic-layout.component').then(
        (m) => m.BasicLayoutComponent,
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/status-pages/not-found/not-found.page').then(
            (m) => m.NotFoundPage,
          ),
        title: 'Page Not Found',
      },
    ],
  },
];
